import React from "react";
function Header(){
    return  <header>
    <h1>Keeper</h1>
    </header>
   
}
export default Header;